import $ from "jquery";

const toggleClass = function () {
    $(this).addClass('button--loading');

    setTimeout(() => {
        $(this).removeClass('button--loading');
    }, 2000);
};

export const buttonsAnimation = () => {
    $('.button--with-animation').on('click', toggleClass);

    $('.button--with-loading-icon').on('click', toggleClass);
}
